import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

export const defaultState = {};

function TILE_SECTION_ADD(state, action) {
	const { id, desktop, tablet, phone, tileIds, name } = action;
	if (!name) {
		return state;
	}

	return {
		...state,
		[id]: {
			id,
			name,
			desktop,
			tablet,
			phone,
			tileIds,
		},
	};
}

function TILE_SECTION_ADD_MULTIPLE(state, action) {
	const { tileSections } = action;
	if (!tileSections || !tileSections.length) {
		return state;
	}

	let nextState = state;
	tileSections.forEach(tile => {
		nextState = TILE_SECTION_ADD(nextState, tile);
	});

	return nextState;
}

function TILE_SECTION_REMOVE(state, action) {
	const { sectionId } = action;
	if (!sectionId || !state[sectionId]) {
		return state;
	}

	const nextState = {
		...state,
	};
	delete nextState[sectionId];

	return nextState;
}

function TILE_SECTION_REMOVE_MULTIPLE(state, action) {
	const { tileSectionIds } = action;
	if (!tileSectionIds || !tileSectionIds.length) {
		return state;
	}

	let nextState = state;
	tileSectionIds.forEach(sectionId => {
		nextState = TILE_SECTION_REMOVE(nextState, { sectionId });
	});

	return nextState;
}

const handlers = {};
handlers[actionTypes.TILE_SECTION_ADD] = TILE_SECTION_ADD;
handlers[actionTypes.TILE_SECTION_ADD_MULTIPLE] = TILE_SECTION_ADD_MULTIPLE;
handlers[actionTypes.TILE_SECTION_REMOVE] = TILE_SECTION_REMOVE;
handlers[actionTypes.BINDER_TABS_REMOVE] = TILE_SECTION_REMOVE_MULTIPLE;
handlers[actionTypes.BINDERS_REMOVE] = TILE_SECTION_REMOVE_MULTIPLE;
handlers[actionTypes.TILE_SECTION_REMOVE_MULTIPLE] = TILE_SECTION_REMOVE_MULTIPLE;
export default createReducer(defaultState, handlers);
